<template>
    <v-container class="pa-0" fluid>
        <v-layout row wrap>
            <v-flex xs12 v-if="showNotification">
                <message-notification-dialog
                        :type="isOnArrival?'Arrival':'Online'"
                />
            </v-flex>
            <v-flex class="hide-on-xs pa-0" md8 xs12>
                <slider :type="'Arrival'"/>
            </v-flex>
            <v-flex md4 xs12>
                <v-card class="full-height d-flex">
                    <v-card-text class="d-flex flex-column">
                        <div>
                            <div class="layout column align-center mt-3">
                                <img :src="logoUrl"
                                     alt="Nepaliport logo"
                                     width="84%"
                                >
                            </div>
                            <div class="mb-4 justify-center" style="display: flex; " v-if="!isOnArrival">
                                <div class="app-name-panel">Online Tourist Visa</div>
                            </div>
                            <div class=" justify-center" style="display: flex; " v-else>
                                <div class="app-name-panel">On-arrival Visa Application</div>
                            </div>
                            <div class=" justify-center mb-4" style="display: flex; " v-if="isOnArrival">
                                <div class="app-name-panel1">{{ officeName }}</div>
                            </div>
                            <v-form class="px-4" lazy-validation ref="form" v-model="valid">
                                <v-layout column wrap>
                                    <form-error-display-handler :errors="errors"/>
                                    <v-flex md12 xs12>
                                        <v-select
                                                :items="languages"
                                                :label="$vuetify.lang.t('$vuetify.select_language') +' *'"
                                                :rules="[rules.required]"
                                                @change="select"
                                                id="select_language"
                                                outlined
                                                v-model="selected"
                                        />
                                    </v-flex>
                                    <v-flex md12 v-if="showOffice" xs12>
                                        <v-autocomplete
                                                :clearable="true"
                                                :items="offices"
                                                :label="$vuetify.lang.t('$vuetify.select_office')+' *'"
                                                :rules="[rules.required]"
                                                id="selectOffice"
                                                item-text="name"
                                                item-value="slug"
                                                outlined
                                                v-model="officeSelected"
                                        />
                                    </v-flex>
                                    <v-flex class="" md12 xs12>
                                        <v-autocomplete
                                                :clearable="true"
                                                :items="countries_list"
                                                :label="$vuetify.lang.t('$vuetify.select_country_of_passport')+' *'"
                                                :rules="[rules.required]"
                                                id="selectCountry"
                                                item-text="country_name"
                                                item-value="id"
                                                outlined
                                                v-model="nationalitySelected"
                                        />
                                    </v-flex>
                                    <v-flex md4 xs12>
                                        <v-select
                                                :clearable="true"
                                                :items="visaTypes"
                                                :label="$vuetify.lang.t('$vuetify.select_visa_type')+' *'"
                                                :rules="[rules.required]"
                                                id="selectVisa"
                                                item-text="type"
                                                item-value="slug"
                                                outlined
                                                v-model="visaSelected"
                                        />
                                    </v-flex>

                                    <v-layout class="mx-0" md12 row wrap>
                                        <v-flex sm12>
                                            <v-text-field
                                                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-2': $vuetify.breakpoint.mdAndUp}"
                                                    :clearable="true"
                                                    :label="$vuetify.lang.t('$vuetify.passport_number')+' *'"
                                                    :rules="[rules.required]"
                                                    outlined
                                                    v-model="passport_number"
                                            />
                                        </v-flex>
                                        <v-flex sm12 mb-4 mx-3>
                                            <date-picker-new v-if="dob && $route.query.dob"
                                                             :label="$vuetify.lang.t('$vuetify.dob_day')+ ' *'"
                                                             v-model="dob"
                                                             :min-year="dateOfBirth.min_year"
                                                             :max-year="dateOfBirth.max_year">
                                            </date-picker-new>
                                            <date-picker-new v-if="!$route.query.dob"
                                                             :label="$vuetify.lang.t('$vuetify.dob_day')+ ' *'"
                                                             v-model="dob"
                                                             :min-year="dateOfBirth.min_year"
                                                             :max-year="dateOfBirth.max_year">
                                            </date-picker-new>
                                        </v-flex>
                                        <!--                                        <v-flex sm12 mb-4 mx-3 v-if="isOnArrival">-->
                                        <!--                                            <date-picker-new-->
                                        <!--                                                    :for-passport="1"-->
                                        <!--                                                    :label="$vuetify.lang.t('$vuetify.passport_day')"-->
                                        <!--                                                    v-model="passport_validity"-->
                                        <!--                                            >-->
                                        <!--                                            </date-picker-new>-->
                                        <!--                                        </v-flex>-->

                                    </v-layout>

                                    <v-flex class="mb-10" md4 xs12>
                                        <v-btn
                                                id="onArrivalBtn"
                                                :loading="visaLoading"
                                                @click="visaSelect"
                                                block
                                                color="primary"
                                                large
                                        >{{ $vuetify.lang.t('$vuetify.proceed') }}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-form>

                            <v-dialog
                                    v-model="prohibitedDialog"
                                    persistent
                                    max-width="500"
                            >
                                <v-card>
                                    <v-card-text class="pt-6">Your country <b>{{ selectedCountry }}</b> is prohibited
                                        for on-arrival visa as
                                        per Immigration laws of Nepal. Please Proceed if you have Recommendation
                                        Letter By Nepal Consular or Nepal Immigration.
                                        For Pre-Arrival VIsa please contact Nearby Nepalese Embassay or Nepal
                                        consular.
                                    </v-card-text>
                                    <v-card-actions class="px-5">
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                class="red lighten-1"
                                                dark
                                                text
                                                @click="prohibitedConfirm(true)"
                                        >Proceed Anyway
                                        </v-btn>
                                        <!--                                        <v-btn-->
                                        <!--                                          color="primary"-->
                                        <!--                                          @click="prohibitedConfirm(false)"-->
                                        <!--                                        >Cancel</v-btn>-->
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                        </div>
                        <v-spacer/>
                        <div>
                            <v-layout wrap>
                                <v-flex class="row justify-center" xs12>
                                    <h5 class="text--darken-1">Developed by &nbsp;</h5>
                                    <img :src="sarkarLogo" alt="Logo Here"
                                         height="20px"
                                         width="24px">
                                    <h4 style="color: black">&nbsp;Department of Immigration, Nepal</h4>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Slider from "./Slider";
import {validationMixin} from "../mixins/validationMixin";
import FormErrorDisplayHandler from "../components/FormErrorDisplayHandler";
import {NEPAL_SARKAR_LOGO, NEPALIPORT_LOGO_URL} from "../constant/appConstant";
import MessageNotificationDialog from "../components/MessageNotificationDialog";
import DatePickerNew from '../components/DatePickerNew';

export default {
    components: {
        MessageNotificationDialog,
        Slider, FormErrorDisplayHandler, DatePickerNew
    },
    mixins: [validationMixin],
    data() {
        return {
            stepper: 0,
            loading: false,
            selected: null,
            nationalitySelected: '',
            prohibitedDialog: false,
            selectedCountry: null,
            alreadyTravelledToNepalBefore: false,
            officeSelected: null,
            visaSelected: "tourist-visa",
            valid: false,
            isOnArrival: false,
            logoUrl: NEPALIPORT_LOGO_URL,
            sarkarLogo: NEPAL_SARKAR_LOGO,
            showNotification: false,
            languages: [
                {
                    text: "English",
                    value: "en"
                },
                {
                    text: "Chinese",
                    value: "cn"
                }
            ],
            dob: "",
            passport_number: "",
            passport_validity: "",
            errors: [],
        };
    },
    watch: {
        nationalitySelected() {
            if (['OnlineApplication', 'OnArrival'].includes(this.$route.name)) {
                this.checkCountryIfProhibited()
            }
        }
    },
    computed: {
        ...mapGetters({
            nationalityLoading: "CountryForTouristList/loading",
            visaLoading: "VisaType/loading",
            visa_types: "VisaType/visa_types",
            countries: 'CountryForTouristList/all',
            office: 'VisaSingle/office',
            apply_type: 'VisaSingle/apply_type',

        }),
        countries_list() {
            const removed_array_code = ['npl', 'ind'];
            return this.countries.filter((co) => {
                return !removed_array_code.includes(co.code.toLowerCase())
            });
        },
        officeName() {
            const office = this.offices.find(i => i.slug.toLowerCase() === this.$route.params.office.toLowerCase());
            if (office !== undefined)
                return office.name;
            return '';
        },
        visaTypes() {
            let visaTypes = this.visa_types;
            if (this.$route.name === 'OnlineApplication') {
                const remove_visa_options = ['transit-visa', 'diplomatic-visa', 'official-visa'];
                visaTypes = visaTypes.filter(visa_type => !remove_visa_options.includes(visa_type.slug));
            }
            if (this.$route.params.office !== 'IO01') {
                const remove_visa_options = ['transit-visa'];
                visaTypes = visaTypes.filter(visa_type => !remove_visa_options.includes(visa_type.slug));
            }
            return visaTypes;
        },
        offices() {
            if (this.$route.name === 'OnlineApplication') {
                // let offices = this.$store.state.Office.offices.filter(i => i.slug !== 'doi');
            }
            return this.$store.state.Office.offices;
        },
        showOffice() {
            return this.$route.name === 'OnlineApplication'
        },
        dateOfBirth() {
            const max_year = parseInt(new Date().toISOString().substr(0, 4));
            const min_year = parseInt(max_year) - 120;
            return {
                min_year,
                max_year
            }
        },
    },
    methods: {
        ...mapActions({
            fetchAllNationalities: "CountryForTouristList/fetchAll",
            searchForVisa: "VisaSingle/searchForVisaIfAny"
        }),
        prohibitedConfirm(proceed) {
            this.prohibitedDialog = false;
            // this.prohibitionConfirm = proceed;
        },
        checkCountryIfProhibited() {
            const nationality = this.countries.find(n => n.id === this.nationalitySelected);
            this.selectedCountry = nationality.country_name
            if (nationality.blacklisted) {

                this.prohibitedDialog = true
            }
        },
        searchVisa() {
            if (this.$route.query.dob) {
                this.callSearchVisa()
            } else {
                if (this.$refs.form.validate()) {
                    this.callSearchVisa()
                }
            }
        },
        visaSelect() {
            if (['OnlineApplication', 'OnArrival'].includes(this.$route.name)) {
                this.checkCountryIfProhibited()
            }

            if (this.$route.query.dob) {
                this.callSelectVisa()
            } else {
                if (this.$refs.form.validate()) {
                    this.callSelectVisa()
                }
            }
        },
        // callSearchVisa() {
        //     this.$store.commit('VisaSingle/setOffice', this.officeSelected);
        //     this.errors = [];
        //
        //     this.searchForVisa({
        //         dob: this.dob,
        //         passport_number: this.passport_number,
        //         office: this.officeSelected,
        //         country: this.nationalitySelected,
        //     })
        //         .then((response) => {
        //           if(!Boolean(response.data.visa_visit.allow_apply_for_valid_visa)){
        //             this.errors.push('You have already applied for ETA Visa. Please proceed to Visa Desk');
        //           } else {
        //             this.$router.push({
        //               name: "VisaApplication",
        //               params: {
        //                 type: this.visaSelected,
        //                 office: this.officeSelected,
        //                 apply: this.apply_type,
        //                 dob: this.dob,
        //                 passport_number: this.passport_number,
        //               }
        //             })
        //           }
        //
        //         })
        //         .catch((err) => {
        //             this.$router.push({
        //                 name: "VisaApplication",
        //                 params: {
        //                     type: this.visaSelected,
        //                     office: this.officeSelected,
        //                     apply: this.apply_type,
        //                     dob: this.dob,
        //                     passport_number: this.passport_number,
        //                 }
        //             })
        //         })
        // },
      callSearchVisa() {
        this.$store.commit('VisaSingle/setOffice', this.officeSelected);
        this.errors = [];

        this.searchForVisa({
          dob: this.dob,
          passport_number: this.passport_number,
          office: this.officeSelected,
          country: this.nationalitySelected,
        })
            .then((response) => {
              if(!Boolean(response.data.visa_visit.allow_apply_for_valid_visa)){
                this.errors.push('You have already applied for ETA Visa. Please proceed to Visa Desk');
              } else {
                const params = new URLSearchParams({
                  country: this.nationalitySelected,
                  visa_type: this.visaSelected,
                  passport_number: this.passport_number,
                  dob: this.dob,
                  full_name: this.$store.state.VisaSingle.full_name || '',
                  passport_validity: this.$store.state.VisaSingle.passport_validity || '',
                  gender: this.$store.state.VisaSingle.gender || '',
                });


                const targetUrl = `https://nepaliport-new.immigration.gov.np/on-arrival/${this.officeSelected}?${params.toString()}`;

                // ✅ Redirect to the visa site
                window.location.href = targetUrl;

                // this.$router.push({
                //
                //   name: "VisaApplication",
                //   params: {
                //     type: this.visaSelected,
                //     office: this.officeSelected,
                //     apply: this.apply_type,
                //     dob: this.dob,
                //     passport_number: this.passport_number,
                //   }
                // })
              }

            })
            .catch((err) => {
              const params = new URLSearchParams({
                country: this.nationalitySelected,
                visa_type: this.visaSelected,
                passport_number: this.passport_number,
                dob: this.dob,
                full_name: this.$store.state.VisaSingle.full_name || '',
                passport_validity: this.$store.state.VisaSingle.passport_validity || '',
                gender: this.$store.state.VisaSingle.gender || '',
              });
              // ?country=1&visa_type=tourist-visa&passport_number=sadasd&dob=2020-06-06&full_name=&passport_validity=&gender=male

              const targetUrl = `https://nepaliport-new.immigration.gov.np/on-arrival/${this.officeSelected}?${params.toString()}`;

              // ✅ Redirect to the visa site
              window.location.href = targetUrl;
              // this.$router.push({
              //     name: "VisaApplication",
              //     params: {
              //         type: this.visaSelected,
              //         office: this.officeSelected,
              //         apply: this.apply_type,
              //         dob: this.dob,
              //         passport_number: this.passport_number,
              //     }
              // })
            })
      },

      callSelectVisa() {
            let nationality = this.countries.find(n => n.id === this.nationalitySelected);
            let visa_selected = this.visa_types.find(n => n.slug === this.visaSelected);
            this.$store.commit("CountryForTouristList/setCurrent", nationality);
            this.$store.commit("VisaType/setVisaType", visa_selected);
            // if (this.isOnArrival) {
            // const office = this.offices.find((i) => i.slug.toLowerCase() === this.officeSelected.toLowerCase());
            // if (office === undefined) {
            //   this.$store.commit('Notification/showError', 'Not a valid office');
            //   return;
            // }
            this.$store.commit('VisaSingle/setLastArrivalCountry', this.nationalitySelected);
            this.$store.commit('VisaSingle/setPassportNumber', this.passport_number);
            this.$store.commit('VisaSingle/setDOB', this.dob);
            // }
            this.$store.commit('VisaSingle/setOffice', this.officeSelected.toLowerCase());
            // if (this.isOnArrival) {
            this.searchVisa();
            // } else {
            //     this.$router.push({
            //         name: "VisaApplication",
            //         params: {
            //             type: this.visaSelected,
            //             office: this.officeSelected,
            //             apply: this.apply_type
            //         }
            //     });
            // }
        },
        select(event) {
            this.selected = event;
            this.$vuetify.lang.current = "" + event;
        }
    }
    ,
    async mounted() {
        const office_type = window.localStorage.getItem('code');

        if (office_type && this.$route.name !== 'OnArrival') {
            window.location.href = '/on-arrival/' + office_type
        }

        this.$store.commit("VisaSingle/resetState");
        this.showNotification = true;
        this.select(this.languages[0].value);

        await this.$store.dispatch('fetchOffices', 'online');
        if (this.$route.name !== 'OnlineApplication') {
            this.isOnArrival = true;
            this.$store.commit('VisaSingle/setApplyType', 'arrival');
            this.officeSelected = this.$route.params.office;
        }
        this.fetchAllNationalities().then(r => {
            if (this.$route.query.country && this.$route.query.passport_number && this.$route.query.dob) {
                this.nationalitySelected = parseInt(this.$route.query.country);
                this.visaSelected = this.$route.query.visa_type;
                this.passport_number = this.$route.query.passport_number;
                this.dob = this.$route.query.dob;
                this.$store.commit('VisaSingle/setFullName', this.$route.query.full_name);
                this.$store.commit('VisaSingle/setGender', this.$route.query.gender);
                this.$store.commit('VisaSingle/setPassportValidity', this.$route.query.passport_validity);
                this.$store.commit('Notification/setFromPrm', true);
                document.getElementById('onArrivalBtn').click()
            }
        });
        this.$store.commit('VisaType/setArrivalVisaTypes');

    }
}
;
</script>
